import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useGameState } from './GameStateContext';
import treeImage from './tree.png';
import AxeImage from './Axe.png';
import MetalAxeImage from './MetalAxe.png';
import BrokenAxeImage from './Broken_Axe.png';
import PowerBarImage from './Power_Bar_1.png';
import LogoImage from './Logo1.png';
import MFGif from './MF.gif';
import Leaderboard from './Leaderboard';
import Inventory from './Inventory';
import './App.css';
import GameOver from './GameOver';

const GameScreen = () => {
    const navigate = useNavigate();
    const axeRef = useRef(null);
    
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setViewportWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [axeVisible, setAxeVisible] = useState(true);
    const backgroundColors = ['#FF973E', '#D2C4E0', '#E7D6A4', '#AA704A', '#D2FDFF', '#455155', '#5D7D86'];
    const [backgroundColor, setBackgroundColor] = useState(backgroundColors[0]);
    const changeBackgroundColor = () => {
        const randomIndex = Math.floor(Math.random() * backgroundColors.length);
        setBackgroundColor(backgroundColors[randomIndex]);
    };

    const [isChopping] = useState(false);
    const [isLocked, setIsLocked] = useState(false);

    const { playerName, scraps, planks, equippedAxe,setScraps } = useGameState();
    const location = useLocation();
    const [showInventory, setShowInventory] = useState(false);
    const [showLeaderboard, setShowLeaderboard] = useState(false);

    const [axeYPosition, setAxeYPosition] = useState(0);
    const [axeLength] = useState(193);

    const [tinyTreePosition, setTinyTreePosition] = useState(0);
    const [tinyTreeDirection, setTinyTreeDirection] = useState(1);
    const [tinyTreeSpeed] = useState(50);
    const [isTinyTreeMoving, setIsTinyTreeMoving] = useState(false);

    const [accuracy, setAccuracy] = useState(null);
    const [power, setPower] = useState(null);
    const [, setResult] = useState(null);

    const [showWinScreen, setShowWinScreen] = useState(false);

    const [axeHitPoints, setAxeHitPoints] = useState(30);
    
    const [earnedScraps, setEarnedScraps] = useState(0);

    const [axeBroken, setAxeBroken] = useState(false);
    const timeoutIdRef = useRef();
    const [axeAnimation, setAxeAnimation] = useState('axe-swing');
    const [scores, setScores] = useState([]);
    const [totalScraps, setTotalScraps] = useState(0); // Total scraps earned in the session
        
    const resetGame = () => {
        // Reset your game state here
        setAxeHitPoints(10); // Reset axe hit points
        setTotalScraps(0); // Reset scraps
        setHighestChopScore(0);
        setAxeHitPoints(10); // Reset highest chop score
        // ... reset any other necessary state
    };
    const [highestChopScore, setHighestChopScore] = useState(0); // Highest chop score in the session
    const playerNameStyle = {
        position: 'absolute',
        top: '10px',
        left: '10px',
        fontSize: '50px',
        color: 'black'
    };
    useEffect(() => {
        if (location.state && location.state.backgroundColor) {
            setBackgroundColor(location.state.backgroundColor);
            const {newAxeHitPoints } = location.state;
            document.body.style.backgroundColor = location.state.backgroundColor;
            setAxeHitPoints(newAxeHitPoints);
        }
    }, [location, setBackgroundColor, setAxeHitPoints]);
    // useEffect for tinyTreeMovement
    useEffect(() => {
        let tinyTreeMovement;
        if (isTinyTreeMoving) {
            tinyTreeMovement = setInterval(() => {
                setTinyTreePosition(prevPosition => {
                    let newPosition = prevPosition + tinyTreeSpeed * tinyTreeDirection;
                    if (newPosition > 400) {
                        newPosition = 400;
                        setTinyTreeDirection(-1);
                    } else if (newPosition < 0) {
                        newPosition = 0;
                        setTinyTreeDirection(1);
                    }
                    return newPosition;
                });
            }, 50);
        }
        return () => clearInterval(tinyTreeMovement);
    }, [isTinyTreeMoving, tinyTreeDirection, tinyTreeSpeed]);

    const lockAxe = () => {
        if (!axeVisible) {
            console.error('Axe is not visible, cannot lock position.');
            return;
        }
        setIsLocked(true); 
        if (axeRef.current) {
            axeRef.current.style.animationPlayState = 'paused'; 
    
            const axeRect = axeRef.current.getBoundingClientRect();
    
            const currentAxeYPosition = axeRect.top + window.scrollY;
            setAxeYPosition(currentAxeYPosition); 
            console.log('Axe locked at Y position:', currentAxeYPosition); 
            
            const treeContainerHeight = 990; 
            const treeMarkerPositionFromTop = treeContainerHeight * 0.8;
            const axeHeadPositionFromTop = axeRect.bottom; 
            const distanceFromTreeMarker = Math.abs(axeHeadPositionFromTop - treeMarkerPositionFromTop);
            
            let accuracyPercentage;
            if (distanceFromTreeMarker > axeLength) {
                accuracyPercentage = 0;
            } else {
                accuracyPercentage = (1 - (distanceFromTreeMarker / axeLength)) * 100;
            }
    
            accuracyPercentage = Math.max(0, Math.min(accuracyPercentage, 100));
            setAccuracy(accuracyPercentage.toFixed(2));
        } else {
            console.error('Axe reference is not currently available.');
        }
        
        setIsTinyTreeMoving(true);
    };
    
    
    const chopWood = () => {
        if (axeBroken) {
            console.log("Axe is broken, exiting chopWood");
            return;
        }
            
        setIsTinyTreeMoving(false);
    
        if (axeRef.current) {
            axeRef.current.style.top = `${axeYPosition}px`;
            axeRef.current.classList.add('enhanced-chop-motion');
    
            timeoutIdRef.current = setTimeout(() => {
                if (axeRef.current) {
                    axeRef.current.classList.remove('enhanced-chop-motion');
                }
            }, 1000); // Duration of the animation
        }
    
        setTimeout(() => {
            if (axeHitPoints <= 0) {
                return <GameOver 
                    backgroundColor={backgroundColor}
                    scrapsEarned={totalScraps}
                    highestChop={highestChopScore}
                    onRestart={resetGame}
                       />;
            }
            if (axeHitPoints > 0) {
                setAxeHitPoints(axeHitPoints - 1);
    
                if (axeHitPoints - 1 <= 0) {
                    setAxeBroken(true);
                    setAxeVisible(false);
                }
            }
    
            const powerAccuracy = 100 - Math.abs((tinyTreePosition - 200) / 250 * 100);
            setPower(Math.max(0, powerAccuracy));
    
            const totalScore = (accuracy * powerAccuracy / 100).toFixed(2);
            let scrapsWon = 0;
            let resultMessage = 'No Wood Chips';
    
            if (totalScore >= 100) {
                scrapsWon = 20;
            } else if (totalScore >= 95) {
                scrapsWon = 1;
            } else if (totalScore >= 90) {
                planks = 2;
            }else if (totalScore >= 85) {
                planks = 1;
            }
    
            setEarnedScraps(scrapsWon);

            setScraps(currentScraps => currentScraps + scrapsWon);
    
            setResult(resultMessage);
    
            sendScoreToServer(playerName, totalScore);
    
            setShowWinScreen(true);
    
        }, 1000 + (timeoutIdRef.current ? 0 : 1000)); // Wait for the enhanced-chop-motion animation to complete
    };
    
    
    
    
    const chopAgain = () => {
        if (axeRef.current && axeYPosition !== null) {
            axeRef.current.style.top = `${axeYPosition}px`;
        }
        setAxeAnimation('axe-swing');
        changeBackgroundColor();
    
        setIsTinyTreeMoving(false);
        if (axeBroken) {
            setAxeVisible(true);
            setAxeBroken(false);
            setAxeHitPoints(equippedAxe && equippedAxe.type === 'Metal' ? 7 : 3);
        }
    
        setShowWinScreen(false);
        setAccuracy(null);
        setPower(null);
        setResult(null);
        setIsLocked(false);
    };
    
    
    
    const sendScoreToServer = async (playerName, score) => {
        try {
            const response = await fetch('https://chopleaderboard.glitch.me/scores', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name: playerName, score })
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            await fetchScores();
        } catch (error) {
            console.error("Error sending score:", error);
        }
    };
    
    

    const goToMarketplace = () => {
        navigate('/marketplace', { state: { backgroundColor, axeHitPoints } });
    };
    
    const toggleLeaderboard = () => {
        setShowLeaderboard(!showLeaderboard);
    };
    const openInventory = () => {
        setShowInventory(!showInventory);
        
    };
    const fetchScores = async () => {
        try {
            const response = await fetch('https://chopleaderboard.glitch.me/scores');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setScores(data);
        } catch (error) {
            console.error('Error fetching scores:', error);
        }
    };
    
    
    useEffect(() => {
        fetchScores();
    }, []);

    if (showWinScreen) {
        const accuracyDisplay = accuracy === 'MISS' ? 'MISS' : `${accuracy}%`;
        const scrapMessage = earnedScraps === 1 ? 'SCRAP' : 'SCRAPS';
      
        return (
            <div style={{ backgroundColor: backgroundColor, height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div>
                    <h2 style={{ fontSize: '50px', color: 'black' }}>Chop Results</h2>
                    <p style={{ fontSize: '25px', color: 'black' }}>
                        Lock Accuracy: <span className="number-display">{accuracyDisplay}</span>
                    </p>
                    <p style={{ fontSize: '25px', color: 'black' }}>
                        Chop Power: <span className="number-display">{power ? power.toFixed(2) : '0.00'}%</span>
                    </p>
                    <p style={{ fontSize: '25px', color: 'black' }}>
                        Overall Accuracy: <span className="number-display">{((accuracy !== 'MISS' ? accuracy : 0) * (power || 0) / 100).toFixed(2)}%</span>
                    </p>
                    <p style={{ fontSize: '50px', color: 'black' }}>
    {accuracy !== 'MISS' && earnedScraps > 0 ? (
        <span>
            You won <span className="number-display">{earnedScraps}</span> {scrapMessage}!
        </span>
    ) : (
        'No Wood chips'
    )}
</p>

                    <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                        <button onClick={chopAgain} style={{ fontSize: '25px' }}>Chop Again</button>
                    </div>
                </div>
            </div>
        );
        
      }
    

    
      return (
        <div style={{ backgroundColor: backgroundColor, height: '100vh', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    
            {/* Animated GIF */}
            <img src={MFGif} alt="Animated GIF" style={{ width: '40%', height: 'auto', position: 'absolute', right: '5%', bottom: '0px', zIndex: 0 }} />
    
            {/* Tree Container */}
            <div className="tree-container">
                <img src={treeImage} alt="Tree" className="tree-image" />
                <div className="tree-markers">
                    {['80%'].map((mark, index) => (
                        <div key={index} className="tree-marker" style={{ top: `${mark}` }}>
                            {mark === '80%' && (
                                <div className="arrow-and-bubble-container">
                                    <div className="arrow-right"></div>
                                    <div className="chat-bubble">Chop here!</div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
    
    
                {axeVisible && (
                    <img ref={axeRef}
                        src={axeBroken ? BrokenAxeImage : equippedAxe && equippedAxe.type === 'Metal' ? MetalAxeImage : AxeImage}
                        alt="Axe"
                        className={`axe ${axeAnimation}`}
                        style={{
                            left: `37%`,
                            width: '35%',
                            height: 'auto',
                            position: 'absolute',
                            transform: 'rotate(-90deg)',
                            transition: 'top 0.9s'
                        }}
                    />
                )}
            </div>
    
            {/* Inventory */}
            {showInventory && <Inventory />}
    
            {/* Power Bar */}
            <img src={PowerBarImage} alt="Power Bar" style={{ width: '2%', height: '570px', position: 'absolute', right: '5%', top: '20%' }} />
            <p style={{
                position: 'absolute',
                right: '3%',
                top: 'calc(13% + 570px + 50px)',
                fontSize: '25px',
                color: 'black',
                fontFamily: "'Dirty Brush', sans-serif"
            }}>Power Bar</p>
    
            {/* Tiny Tree */}
            <img src={treeImage} alt="Tiny Tree" style={{ width: '2%', height: 'auto', position: 'absolute', right: '5%', top: `${250 + tinyTreePosition}px`, transform: 'rotate(90deg)' }} />
    
            {/* Logo */}
            <img src={LogoImage} alt="Logo" style={{ position: 'absolute', top: '5%', left: '50%', transform: 'translateX(-50%)', width: '33%', height: 'auto' }} />
    
            {/* Player Name */}
            <div style={playerNameStyle}>{playerName}</div>
    
            {/* Buttons */}
            <button onClick={lockAxe} className="lock-button" style={{ fontSize: viewportWidth >= 600 ? '20px' : '10px' }} disabled={isChopping}>Lock</button>
            <button onClick={chopWood} className="chop-button" style={{ fontSize: viewportWidth >= 600 ? '20px' : '10px' }} disabled={!isLocked}>CHOP</button>
    
            {/* Axe Hitpoints Display */}
            <div className="axe-hitpoints-display" style={{ position: 'absolute', right: '2%', top: '5%', fontSize: viewportWidth >= 600 ? '20px' : '10px' }}>
                Axe Hitpoints: <span className="number-display">{axeHitPoints}</span>
            </div>
    
            {/* Planks and Scraps Display */}
            <div className="planks-scraps-display" style={{ position: 'absolute', right: '2%', top: '1%', fontSize: viewportWidth >= 600 ? '20px' : '10px' }}>
                LUMBER: <span className="number-display">{planks}</span>, WOOD CHIPS: <span className="number-display">{scraps}</span>
            </div>
            
            <button onClick={toggleLeaderboard} style={{ position: 'absolute', left: '44%', bottom: '95%', fontSize: viewportWidth >= 600 ? '20px' : '10px' }}>Leaderboard</button>
            
            {showLeaderboard && <Leaderboard scores={scores} />}
        </div>
    );
}        

export default GameScreen;

